<template>
    <program-alert v-if="recentStudentReports.length">
        <span class="mr-2">Recently completed reports</span>
        <template v-for="(student, index) in recentStudentReports">
            <v-chip
                class="mr-3"
                :key="`chip-${index}`"
                small
                color="secondary darken-2"
            >
                {{ student.name }}
                {{ student.hours }} hours ago
            </v-chip>
        </template>
    </program-alert>
</template>

<script>
export default {
    name: "program-instructor-alert",
    components: {
        ProgramAlert: () =>
            import("@/components/program/components/ProgramAlert.vue"),
    },
    props: {
        instructor: {
            type: Object,
            required: true,
        },
    },
    computed: {
        recentStudentReports() {
            return this.$_.get(this.instructor, "students", [])
                .filter((student) => this.$_.get(student, "order.new", false))
                .map((student) => {
                    return {
                        name: student.name,
                        hours: student.order.hours_since_completion,
                    };
                });
        },
    },
};
</script>

<style lang="scss" scoped>
</style>